import DetailOffers from 'Pages/DetailOffers'
import PaymentMethod from 'Pages/PaymentMethod'

export const publicRoutes = [
	{
		component: DetailOffers,
		name: 'Detail Offers',
		route: '/package-:id',
	},
	{
		component: PaymentMethod,
		name: 'Payment Method',
		route: '/payment-method',
	},
]
